export default {
  page: 'Seite',
  layoutSubtitle: 'Leere Einstellungen werden aus dem Basislayout übernommen.',
  blocksSubtitle: 'Die Blöcke erscheinen in dieser Reihenfolge im Bericht. Ziehen Sie einen Block an seinem Griff, um ihn zu verschieben.',
  resetBlocks: 'Die Standardblöcke des Berichts verwenden',
};
